var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEmptyList = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 32,
  height: 32,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M24 17.333v9.334H5.333V8h6.694c.066-.947.293-1.84.64-2.667H5.332A2.675 2.675 0 0 0 2.666 8v18.667c0 1.466 1.2 2.666 2.667 2.666H24c1.466 0 2.666-1.2 2.666-2.666V20L24 17.333Zm1.733-5.48a5.947 5.947 0 0 0 .933-3.186c0-3.32-2.68-6-6-6s-6 2.68-6 6 2.68 6 5.987 6a5.912 5.912 0 0 0 3.187-.934l4.16 4.16L29.893 16l-4.16-4.147ZM20.666 12a3.335 3.335 0 0 1 0-6.667 3.335 3.335 0 0 1 0 6.667Z",
  fill: "#000",
  fillOpacity: 0.26
})));
export default SvgEmptyList;